import { render, staticRenderFns } from "./ProjectsDurationMetricCard.vue?vue&type=template&id=666a6e39&scoped=true&"
import script from "./ProjectsDurationMetricCard.vue?vue&type=script&lang=js&"
export * from "./ProjectsDurationMetricCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsDurationMetricCard.vue?vue&type=style&index=0&id=666a6e39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666a6e39",
  null
  
)

export default component.exports